import { createElementFromString, clear } from '../helper/helper';
import MobileSidebar from './mobileSidebar';

export default class Events {
	constructor() {
		this.wrap = document.getElementById('events--main');

		this.sidebar = new MobileSidebar({
			sidebar: document.getElementById('gr-events--sidebar'),
			toggle: document.querySelector('.mobile--sidebar_toggle')
		});

		jQuery(document.body).on('hpy_events_events_added', (e, response) => {
			this.loadNewEvents(response);
			this.sidebar.maybeCloseSidebar();
		});

	}

	loadNewEvents(response) {
		if (!response || !response.products) {
			return;
		}

		const products = createElementFromString(response.products);

		clear(this.wrap);

		if (products.children && response.products_found) {
			[...products.children].forEach(product => this.wrap.insertAdjacentElement('beforeend', product));
		} else {
			this.wrap.insertAdjacentElement('beforeend', products);
		}
	}


}